<template>
  <div class="empresa-contabilidad-container">
    <v-card class="pa-0 pa-sm-4">
      <v-container fluid class="px-2 px-sm-3">
        <v-row align="center" justify="space-between">
          <v-col cols="12" md="8">
            <div class="d-flex flex-column gap-2">
              <div class="font-weight-bold mb-1" :class="$vuetify.breakpoint.xsOnly ? 'text-h6' : 'text-h5'">
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 28 : 36" class="mb-2">mdi-folder</v-icon> Categorías
              </div>
              <div class="text--secondary" :class="$vuetify.breakpoint.xsOnly ? 'text-body-2' : 'text-subtitle-1'">
                Administra y consulta las categorías de la empresa. Organizá tu
                catálogo para facilitar búsquedas y reportes.
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Contenido dinámico de las pestañas -->
        <router-view ></router-view>
      </v-container>
    </v-card>
  </div>
</template>

  
  <script>
import { mapActions, mapState } from "vuex";
import ProductoCategoriaCreate from "@/components/producto/categorias/ProductoCategoriaCreate";
import CategoriasAPI from "@/api/categorias";

export default {
  name: "EmpresaCategorias",
  components: { ProductoCategoriaCreate },

  computed: {},
  data() {
    return {};
  },
};
</script>
  
  <style lang="scss" scoped>
.empresa-contabilidad-container {
  padding: 20px;

  .status-section {
    margin-bottom: 20px;
  }

  .actions-section {
    margin: 20px 0;
    gap: 10px;
  }

  v-alert {
    margin-bottom: 15px;
  }
}
</style>
  